import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import { SuccessMessage } from "sr/helpers/functions/SuccessMessage";
import ApiResponse from "sr/models/ApiResponse";
import { put } from "sr/utils/axios";

export const resendSupervisor = async (postData:any) => {
    try {
  return await put<ApiResponse<[]>>('/supervisor/resendregistrationemail', postData).then((res)=> {
    if(res?.success===true) {
        SuccessMessage('API.SUCCESS.SUPERVISOR.RESEND.EMAIL')
        return res
    }
    else {
        return null
    }
  })
}
catch(e:any) {
    HandleApiError(e)
}
};
